<template>
  <Modal :open="isModalOpen" :close-button-exists="false" :is-small="true">
    <img src="/images/spinner.gif" alt="spinner" class="mx-auto mb-8 h-20 w-20">
    <div class="mt-3 text-center sm:mt-5">
      <h3
          class="mx-auto w-3/4 text-xl font-semibold leading-6 text-green-400"
          id="modal-headline"
      >
        <span>Ihre Daten werden geprüft.<br /> Einen Moment...</span>
      </h3>
      <div class="mt-6 flex justify-center">
        <div class="flex flex-col items-start text-sm text-gray-500 space-y-2 sm:pl-16">
          <div>
            <img v-show="!showSpinnerOne" src="/images/spinner.gif" alt="spinner"
                 class="fixed mx-auto inline h-5 w-5 text-base text-green-600"
            >
            <i v-show="showSpinnerOne" class="fixed inline text-base text-green-400 fas fa-check"></i>
            <span class="ml-6">Daten werden registriert</span>
          </div>
          <div>
            <img v-show="!showSpinnerTwo" src="/images/spinner.gif" alt="spinner" class="inline fixed text-base text-green-600 mx-auto h-5 w-5">
            <i v-show="showSpinnerTwo" class="fixed inline text-base text-green-400 fas fa-check"></i>
            <span class="ml-6">{{ isGuarantee ? 'Bürgschaft wird hinterlegt' :'Daten werden überprüft' }}</span>
          </div>
          <div>
            <img v-show="!showSpinnerThree" src="/images/spinner.gif" alt="spinner" class="fixed mx-auto inline h-5 w-5 text-base text-green-600">
            <i v-show="showSpinnerThree" class="fixed inline text-base text-green-400 fas fa-check"></i>
            <span class="ml-6">{{ isGuarantee ? 'Bürgschaftsurkunde wird erstellt' : 'Antrag wird verarbeitet' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5 sm:mt-6"
         :class="{' hidden ' : (!isDev)}">
      <button type="button"
              class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
              @click="tenant.stopStatusQuery">
        Remove Modal (for testing)
      </button>
    </div>
  </Modal>
</template>

<script setup>
import Modal from "../../common/components/Modal";
import { computed } from 'vue';
import { useTenantStore } from '../stores/tenant';

const tenant = useTenantStore();
const isModalOpen = computed(() => tenant.processing.isProcessingModalOpen);
const showSpinnerOne = computed(() => tenant.processing.showSpinnerOne);
const showSpinnerTwo = computed(() => tenant.processing.showSpinnerTwo);
const showSpinnerThree = computed(() => tenant.processing.showSpinnerThree);
const isGuarantee = computed(() => tenant.processing.requestedState === 'finished');

const isDev = computed(() => {
  if (window.location.href.includes('reports.test') || window.location.href.includes('dev.heysafe.de')) {
    return true;
  }
  return false;
});

</script>